var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"spacer",attrs:{"id":"festival"}},[_c('div',{staticClass:"title big"},[_vm._v(_vm._s(_vm.festival.title))]),_c('div',{staticClass:"pt mbs big",domProps:{"innerHTML":_vm._s(_vm.festival.text)}}),_c('testimonials')],1)}
var staticRenderFns = []

export { render, staticRenderFns }